import { CellType, ExcelColorValue, UploadStatus, Constants } from "../../util/UIConstants";
import { IColumnConfig } from "../configuration";
import { labels, currentResource } from "../../util/utils";
import Utility from "../../util/utilityFunctions";

export class TimePhaseConfiguration implements IColumnConfig {
  rowheader: any[];
  columns: any[];

  constructor() {
    this.columns = [
      {
        CellHeader: labels.status,
        CellId: "UploadStatus",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return `${currentResource.uploadStatusLabels[UploadStatus.Downloaded]}`;
        },
      },
      {
        CellHeader: labels.updateCanvas,
        IsMarkValue: true, // This can be only one
        CellId: "MarkForUpdate",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
        },
        getCellData: (data) => {
          return Constants.MarkForUpdateNo;
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return Utility.updateEYCanvasDropDownValues;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.timePhaseName,
        CellId: "TimePhaseName",
        CellFormat: {
          locked: false,
          requiredColumnWidth: 278.57,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.periodName;
        },
      },
      {
        CellHeader: labels.milestoneRequired,
        CellId: "TimePhaseTypeId",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.timephaseTypes.find((x) => x.value === data.timePhaseTypeId);
          return dataObject ? dataObject.label : "";
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage ? userLanguage.timephaseTypes : currentResource.timephaseTypes;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.startDate,
        CellId: "StartDate",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          dateFormat: true,
        },
        getCellData: (data) => {
          return data.startDate ? data.startDate.split("T")[0] : "";
        },
      },
      {
        CellHeader: labels.endDate,
        CellId: "DueDate",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          dateFormat: true,
        },
        getCellData: (data) => {
          return data.dueDate ? data.dueDate.split("T")[0] : "";
        },
      },
      {
        CellHeader: labels.keyEvent,
        CellId: "IsKeyEvent",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.YesNoTypes.find((x) => x.booleanValue === data.isKeyEvent);
          return dataObject ? dataObject.label : "";
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage ? userLanguage.YesNoTypes : currentResource.YesNoTypes;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.timePhaseName + " ",
        CellId: "OriginalTimePhaseName",
        CellFormat: {
          locked: true,
          requiredColumnWidth: 278.57,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.periodName;
        },
      },
      {
        CellHeader: labels.milestoneRequired + " ",
        CellId: "OriginalTimePhaseTypeId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.timephaseTypes.find((x) => x.value === data.timePhaseTypeId);
          return dataObject ? dataObject.label : "";
        },
      },
      {
        CellHeader: labels.startDate + " ",
        CellId: "OriginalStartDate",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          dateFormat: true,
        },
        getCellData: (data) => {
          return data.startDate ? data.startDate.split("T")[0] : "";
        },
      },
      {
        CellHeader: labels.endDate + " ",
        CellId: "OriginalDueDate",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          dateFormat: true,
        },
        getCellData: (data) => {
          return data.dueDate ? data.dueDate.split("T")[0] : "";
        },
      },
      {
        CellHeader: labels.keyEvent + " ",
        CellId: "OriginalIsKeyEvent",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.YesNoTypes.find((x) => x.booleanValue === data.isKeyEvent);
          return dataObject ? dataObject.label : "";
        },
      },
      {
        CellHeader: labels.timePhaseId + " ",
        CellId: "TimePhaseId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return data.id;
        },
      },
      {
        CellHeader: labels.hash,
        CellId: "HashValue",
        HashAttribue: {
          HashCalculatedDataattributesName: [
            {
              CellId: "TimePhaseName",
            },
            {
              CellId: "TimePhaseTypeId",
            },
            {
              CellId: "StartDate",
            },
            {
              CellId: "DueDate",
            },
            {
              CellId: "IsKeyEvent",
            },
          ],
        },
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          let hashValue: string = "";
          hashValue = Utility.getHashValueForRow(this.columns, [], data); // can be more then one
          return hashValue;
        },
      },
      {
        CellHeader: labels.statusId,
        CellType: CellType.DynamicCell,
        CellId: "UploadStatusId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return `${UploadStatus.Downloaded}`;
        },
      },
    ];
    this.rowheader = [
      {
        CellHeader: labels.referenceOnly,
        DisplayRange: ["A1:A1", "H1:L1"],
        CellFormat: {
          locked: true,
        },
      },
      {
        CellHeader: labels.columnsToUpdate,
        DisplayRange: ["B1:G1"],
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.GrayColor,
        },
      },
    ];
  }
}
